class CartTimer extends HTMLElement {
    constructor() {
        super();

        this.currentInterval = null;
        this.cartCountdowns = document.querySelectorAll('.cartCountdown');
        this.initTimer();
    }

    getWithExpiry(key) {
        const itemStr = localStorage.getItem(key)
        if (!itemStr) {
            return null
        }
        const item = JSON.parse(itemStr)
        const now = new Date()
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }

    setWithExpiry(key, value) {
        const now = new Date()
        const ttl = 60 * 60 * 24;

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    }

    setCountdown(value) {
        this.cartCountdowns.forEach(elem => elem.textContent = value);
    }
  
  	hideAlerts(){
    	document.querySelectorAll(".cartCountdownAlert").forEach(elem => elem.classList.add("hideAlert"));
    }

    startTimer(duration, display) {
        var timer = duration,
            minutes, seconds;
        this.currentInterval = setInterval(() => {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            this.setCountdown(`${minutes}:${seconds}`);
            this.setWithExpiry('cartTimer', timer);
            if (--timer < 0) {
                this.hideAlerts();
                clearInterval(this.currentInterval)
                this.currentInterval = null;
            }

        }, 1000);
    }

    initTimer() {
        var currentValue = parseInt(this.getWithExpiry('cartTimer'));

        if (!this.currentInterval && currentValue > 0) {
            var minutes = parseInt(currentValue / 60, 10);
            var seconds = parseInt(currentValue % 60, 10);

            minutes = minutes < 10 ? `0${minutes}` : minutes;
            seconds = seconds < 10 ? `0${seconds}` : seconds;

            this.setCountdown(`${minutes}:${seconds}`);
            this.startTimer((currentValue-1), this.cartCountdown);

            document.querySelectorAll(".cartCountdownAlert").forEach(elem => elem.classList.remove("hideAlert"));

        }
        if (currentValue == 0) {
            this.hideAlerts();
        }
    }

    productAddedToCart() {
        var tenMinutes = 60 * 10;
        if (this.currentInterval) {
            clearInterval(this.currentInterval)
            this.currentInterval = null;
        }
		var minutes = parseInt(tenMinutes / 60, 10);
        var seconds = parseInt(tenMinutes % 60, 10);

		minutes = minutes < 10 ? `0${minutes}` : minutes;
        seconds = seconds < 10 ? `0${seconds}` : seconds;

        this.setCountdown(`${minutes}:${seconds}`);
        document.querySelectorAll(".cartCountdownAlert").forEach(elem => elem.classList.remove("hideAlert"));
      	this.startTimer((tenMinutes-1), this.cartCountdown);
    }

    cartCleared(){
		this.hideAlerts();
      	if (this.currentInterval) {
            clearInterval(this.currentInterval)
            this.currentInterval = null;
        }
        this.setWithExpiry('cartTimer', 0);
    }

}

customElements.define('cart-timer', CartTimer);